var pointData = [
    {
        "x": 0.4483795762062073,
        "y": 0.8468796014785767,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 248525,
            "instrument_source_str": "electronic",
            "velocity": 127,
            "instrument_str": "organ_electronic_001",
            "instrument": 8,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_001-060-127",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_001-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_001-060-127.wav"
    },
    {
        "x": 0.7010920643806458,
        "y": 0.07795789837837219,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 214594,
            "instrument_source_str": "electronic",
            "velocity": 50,
            "instrument_str": "keyboard_electronic_002",
            "instrument": 50,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 1,
            "note_str": "keyboard_electronic_002-060-050",
            "instrument_family": 4,
            "instrument_family_str": "keyboard",
            "filepath": "./data/nsynth/nsynth-test/audio/keyboard_electronic_002-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/keyboard_electronic_002-060-050.wav"
    },
    {
        "x": 0.2919043302536011,
        "y": 0.46215057373046875,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 171697,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "guitar_acoustic_014",
            "instrument": 263,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "guitar_acoustic_014-060-127",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_acoustic_014-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_acoustic_014-060-127.wav"
    },
    {
        "x": 0.7611807584762573,
        "y": 0.28086113929748535,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 99452,
            "instrument_source_str": "acoustic",
            "velocity": 100,
            "instrument_str": "reed_acoustic_037",
            "instrument": 387,
            "sample_rate": 16000,
            "qualities_str": [
                "long_release",
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "reed_acoustic_037-060-100",
            "instrument_family": 7,
            "instrument_family_str": "reed",
            "filepath": "./data/nsynth/nsynth-test/audio/reed_acoustic_037-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/reed_acoustic_037-060-100.wav"
    },
    {
        "x": 0.5187041759490967,
        "y": 0.9300402402877808,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 46654,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "organ_electronic_028",
            "instrument": 440,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_028-060-075",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_028-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_028-060-075.wav"
    },
    {
        "x": 0.5102676153182983,
        "y": 0.8108569979667664,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 248159,
            "instrument_source_str": "electronic",
            "velocity": 100,
            "instrument_str": "organ_electronic_001",
            "instrument": 8,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_001-060-100",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_001-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_001-060-100.wav"
    },
    {
        "x": 0.9146507978439331,
        "y": 0.3410831093788147,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 39008,
            "instrument_source_str": "acoustic",
            "velocity": 75,
            "instrument_str": "vocal_acoustic_000",
            "instrument": 46,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "vocal_acoustic_000-060-075",
            "instrument_family": 10,
            "instrument_family_str": "vocal",
            "filepath": "./data/nsynth/nsynth-test/audio/vocal_acoustic_000-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/vocal_acoustic_000-060-075.wav"
    },
    {
        "x": 0.3593403995037079,
        "y": 0.6548265218734741,
        "metadata": {
            "qualities": [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 195359,
            "instrument_source_str": "synthetic",
            "velocity": 127,
            "instrument_str": "bass_synthetic_098",
            "instrument": 803,
            "sample_rate": 16000,
            "qualities_str": [
                "distortion"
            ],
            "instrument_source": 2,
            "note_str": "bass_synthetic_098-060-127",
            "instrument_family": 0,
            "instrument_family_str": "bass",
            "filepath": "./data/nsynth/nsynth-test/audio/bass_synthetic_098-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/bass_synthetic_098-060-127.wav"
    },
    {
        "x": 0.7562531232833862,
        "y": 0.6278260946273804,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 49955,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "brass_acoustic_015",
            "instrument": 121,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "brass_acoustic_015-060-127",
            "instrument_family": 1,
            "instrument_family_str": "brass",
            "filepath": "./data/nsynth/nsynth-test/audio/brass_acoustic_015-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/brass_acoustic_015-060-127.wav"
    },
    {
        "x": 0.7859366536140442,
        "y": 0.05228477716445923,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 195526,
            "instrument_source_str": "synthetic",
            "velocity": 50,
            "instrument_str": "bass_synthetic_068",
            "instrument": 656,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 2,
            "note_str": "bass_synthetic_068-060-050",
            "instrument_family": 0,
            "instrument_family_str": "bass",
            "filepath": "./data/nsynth/nsynth-test/audio/bass_synthetic_068-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/bass_synthetic_068-060-050.wav"
    },
    {
        "x": 0.8594753742218018,
        "y": 0.018090426921844482,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 23664,
            "instrument_source_str": "acoustic",
            "velocity": 50,
            "instrument_str": "mallet_acoustic_062",
            "instrument": 644,
            "sample_rate": 16000,
            "qualities_str": [
                "dark",
                "fast_decay",
                "multiphonic"
            ],
            "instrument_source": 0,
            "note_str": "mallet_acoustic_062-060-050",
            "instrument_family": 5,
            "instrument_family_str": "mallet",
            "filepath": "./data/nsynth/nsynth-test/audio/mallet_acoustic_062-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/mallet_acoustic_062-060-050.wav"
    },
    {
        "x": 0.7862987518310547,
        "y": 0.0,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 186444,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "mallet_acoustic_062",
            "instrument": 644,
            "sample_rate": 16000,
            "qualities_str": [
                "dark",
                "long_release",
                "multiphonic"
            ],
            "instrument_source": 0,
            "note_str": "mallet_acoustic_062-060-127",
            "instrument_family": 5,
            "instrument_family_str": "mallet",
            "filepath": "./data/nsynth/nsynth-test/audio/mallet_acoustic_062-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/mallet_acoustic_062-060-127.wav"
    },
    {
        "x": 0.707862377166748,
        "y": 0.27155840396881104,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 124660,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "reed_acoustic_037",
            "instrument": 387,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "reed_acoustic_037-060-127",
            "instrument_family": 7,
            "instrument_family_str": "reed",
            "filepath": "./data/nsynth/nsynth-test/audio/reed_acoustic_037-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/reed_acoustic_037-060-127.wav"
    },
    {
        "x": 0.12886372208595276,
        "y": 0.4217939078807831,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 38914,
            "instrument_source_str": "acoustic",
            "velocity": 75,
            "instrument_str": "string_acoustic_056",
            "instrument": 436,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "string_acoustic_056-060-075",
            "instrument_family": 8,
            "instrument_family_str": "string",
            "filepath": "./data/nsynth/nsynth-test/audio/string_acoustic_056-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/string_acoustic_056-060-075.wav"
    },
    {
        "x": 0.06430357694625854,
        "y": 0.43432119488716125,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 142985,
            "instrument_source_str": "acoustic",
            "velocity": 25,
            "instrument_str": "guitar_acoustic_015",
            "instrument": 316,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "guitar_acoustic_015-060-025",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_acoustic_015-060-025.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_acoustic_015-060-025.wav"
    },
    {
        "x": 0.3328317701816559,
        "y": 0.030617713928222656,
        "metadata": {
            "qualities": [
                0,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 187419,
            "instrument_source_str": "electronic",
            "velocity": 127,
            "instrument_str": "organ_electronic_007",
            "instrument": 123,
            "sample_rate": 16000,
            "qualities_str": [
                "distortion",
                "long_release",
                "nonlinear_env"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_007-060-127",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_007-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_007-060-127.wav"
    },
    {
        "x": 0.28415435552597046,
        "y": 0.2075793594121933,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 145325,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "keyboard_electronic_003",
            "instrument": 65,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 1,
            "note_str": "keyboard_electronic_003-060-075",
            "instrument_family": 4,
            "instrument_family_str": "keyboard",
            "filepath": "./data/nsynth/nsynth-test/audio/keyboard_electronic_003-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/keyboard_electronic_003-060-075.wav"
    },
    {
        "x": 0.0067980289459228516,
        "y": 0.5385754704475403,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 88712,
            "instrument_source_str": "acoustic",
            "velocity": 100,
            "instrument_str": "guitar_acoustic_010",
            "instrument": 219,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "guitar_acoustic_010-060-100",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_acoustic_010-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_acoustic_010-060-100.wav"
    },
    {
        "x": 0.2590486407279968,
        "y": 0.14149349927902222,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 289571,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "guitar_electronic_022",
            "instrument": 378,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "guitar_electronic_022-060-075",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_electronic_022-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_electronic_022-060-075.wav"
    },
    {
        "x": 0.6888021230697632,
        "y": 0.6521435379981995,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 22633,
            "instrument_source_str": "acoustic",
            "velocity": 100,
            "instrument_str": "brass_acoustic_006",
            "instrument": 43,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "brass_acoustic_006-060-100",
            "instrument_family": 1,
            "instrument_family_str": "brass",
            "filepath": "./data/nsynth/nsynth-test/audio/brass_acoustic_006-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/brass_acoustic_006-060-100.wav"
    },
    {
        "x": 0.2976728081703186,
        "y": 0.6027023792266846,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ],
            "pitch": 60,
            "note": 19951,
            "instrument_source_str": "acoustic",
            "velocity": 75,
            "instrument_str": "guitar_acoustic_030",
            "instrument": 642,
            "sample_rate": 16000,
            "qualities_str": [
                "tempo-synced"
            ],
            "instrument_source": 0,
            "note_str": "guitar_acoustic_030-060-075",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_acoustic_030-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_acoustic_030-060-075.wav"
    },
    {
        "x": 0.8356413841247559,
        "y": 0.34532415866851807,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 20373,
            "instrument_source_str": "acoustic",
            "velocity": 50,
            "instrument_str": "vocal_acoustic_000",
            "instrument": 46,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "vocal_acoustic_000-060-050",
            "instrument_family": 10,
            "instrument_family_str": "vocal",
            "filepath": "./data/nsynth/nsynth-test/audio/vocal_acoustic_000-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/vocal_acoustic_000-060-050.wav"
    },
    {
        "x": 0.6815826892852783,
        "y": 0.7043733596801758,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 40899,
            "instrument_source_str": "acoustic",
            "velocity": 100,
            "instrument_str": "brass_acoustic_059",
            "instrument": 572,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "brass_acoustic_059-060-100",
            "instrument_family": 1,
            "instrument_family_str": "brass",
            "filepath": "./data/nsynth/nsynth-test/audio/brass_acoustic_059-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/brass_acoustic_059-060-100.wav"
    },
    {
        "x": 0.2863832116127014,
        "y": 0.6640745997428894,
        "metadata": {
            "qualities": [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 270901,
            "instrument_source_str": "synthetic",
            "velocity": 127,
            "instrument_str": "bass_synthetic_135",
            "instrument": 927,
            "sample_rate": 16000,
            "qualities_str": [
                "distortion"
            ],
            "instrument_source": 2,
            "note_str": "bass_synthetic_135-060-127",
            "instrument_family": 0,
            "instrument_family_str": "bass",
            "filepath": "./data/nsynth/nsynth-test/audio/bass_synthetic_135-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/bass_synthetic_135-060-127.wav"
    },
    {
        "x": 0.91756272315979,
        "y": 0.42755940556526184,
        "metadata": {
            "qualities": [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 11048,
            "instrument_source_str": "acoustic",
            "velocity": 50,
            "instrument_str": "brass_acoustic_016",
            "instrument": 128,
            "sample_rate": 16000,
            "qualities_str": [
                "bright"
            ],
            "instrument_source": 0,
            "note_str": "brass_acoustic_016-060-050",
            "instrument_family": 1,
            "instrument_family_str": "brass",
            "filepath": "./data/nsynth/nsynth-test/audio/brass_acoustic_016-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/brass_acoustic_016-060-050.wav"
    },
    {
        "x": 0.34920579195022583,
        "y": 0.19026847183704376,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 265999,
            "instrument_source_str": "electronic",
            "velocity": 50,
            "instrument_str": "keyboard_electronic_003",
            "instrument": 65,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "keyboard_electronic_003-060-050",
            "instrument_family": 4,
            "instrument_family_str": "keyboard",
            "filepath": "./data/nsynth/nsynth-test/audio/keyboard_electronic_003-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/keyboard_electronic_003-060-050.wav"
    },
    {
        "x": 0.6303583979606628,
        "y": 0.09894460439682007,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 86781,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "guitar_electronic_028",
            "instrument": 510,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "guitar_electronic_028-060-075",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_electronic_028-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_electronic_028-060-075.wav"
    },
    {
        "x": 0.03959977626800537,
        "y": 0.5836809277534485,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 11496,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "guitar_acoustic_010",
            "instrument": 219,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "guitar_acoustic_010-060-127",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_acoustic_010-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_acoustic_010-060-127.wav"
    },
    {
        "x": 0.2698434591293335,
        "y": 0.02126184105873108,
        "metadata": {
            "qualities": [
                1,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 37828,
            "instrument_source_str": "synthetic",
            "velocity": 100,
            "instrument_str": "vocal_synthetic_003",
            "instrument": 37,
            "sample_rate": 16000,
            "qualities_str": [
                "bright",
                "distortion",
                "long_release",
                "nonlinear_env"
            ],
            "instrument_source": 2,
            "note_str": "vocal_synthetic_003-060-100",
            "instrument_family": 10,
            "instrument_family_str": "vocal",
            "filepath": "./data/nsynth/nsynth-test/audio/vocal_synthetic_003-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/vocal_synthetic_003-060-100.wav"
    },
    {
        "x": 0.40584781765937805,
        "y": 1.0,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 79210,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "organ_electronic_104",
            "instrument": 921,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 1,
            "note_str": "organ_electronic_104-060-075",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_104-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_104-060-075.wav"
    },
    {
        "x": 0.9564241170883179,
        "y": 0.47526124119758606,
        "metadata": {
            "qualities": [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 44405,
            "instrument_source_str": "acoustic",
            "velocity": 75,
            "instrument_str": "brass_acoustic_016",
            "instrument": 128,
            "sample_rate": 16000,
            "qualities_str": [
                "bright"
            ],
            "instrument_source": 0,
            "note_str": "brass_acoustic_016-060-075",
            "instrument_family": 1,
            "instrument_family_str": "brass",
            "filepath": "./data/nsynth/nsynth-test/audio/brass_acoustic_016-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/brass_acoustic_016-060-075.wav"
    },
    {
        "x": 0.19095167517662048,
        "y": 0.5726314783096313,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 93848,
            "instrument_source_str": "acoustic",
            "velocity": 25,
            "instrument_str": "string_acoustic_014",
            "instrument": 100,
            "sample_rate": 16000,
            "qualities_str": [
                "dark",
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "string_acoustic_014-060-025",
            "instrument_family": 8,
            "instrument_family_str": "string",
            "filepath": "./data/nsynth/nsynth-test/audio/string_acoustic_014-060-025.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/string_acoustic_014-060-025.wav"
    },
    {
        "x": 0.33594846725463867,
        "y": 0.11921839416027069,
        "metadata": {
            "qualities": [
                1,
                0,
                1,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 271706,
            "instrument_source_str": "synthetic",
            "velocity": 100,
            "instrument_str": "bass_synthetic_009",
            "instrument": 150,
            "sample_rate": 16000,
            "qualities_str": [
                "bright",
                "distortion",
                "long_release"
            ],
            "instrument_source": 2,
            "note_str": "bass_synthetic_009-060-100",
            "instrument_family": 0,
            "instrument_family_str": "bass",
            "filepath": "./data/nsynth/nsynth-test/audio/bass_synthetic_009-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/bass_synthetic_009-060-100.wav"
    },
    {
        "x": 0.8954031467437744,
        "y": 0.4886254370212555,
        "metadata": {
            "qualities": [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 14716,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "brass_acoustic_016",
            "instrument": 128,
            "sample_rate": 16000,
            "qualities_str": [
                "bright"
            ],
            "instrument_source": 0,
            "note_str": "brass_acoustic_016-060-127",
            "instrument_family": 1,
            "instrument_family_str": "brass",
            "filepath": "./data/nsynth/nsynth-test/audio/brass_acoustic_016-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/brass_acoustic_016-060-127.wav"
    },
    {
        "x": 0.21321266889572144,
        "y": 0.5103340744972229,
        "metadata": {
            "qualities": [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 293752,
            "instrument_source_str": "electronic",
            "velocity": 100,
            "instrument_str": "keyboard_electronic_069",
            "instrument": 805,
            "sample_rate": 16000,
            "qualities_str": [
                "distortion"
            ],
            "instrument_source": 1,
            "note_str": "keyboard_electronic_069-060-100",
            "instrument_family": 4,
            "instrument_family_str": "keyboard",
            "filepath": "./data/nsynth/nsynth-test/audio/keyboard_electronic_069-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/keyboard_electronic_069-060-100.wav"
    },
    {
        "x": 0.9664539098739624,
        "y": 0.39385056495666504,
        "metadata": {
            "qualities": [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 82831,
            "instrument_source_str": "synthetic",
            "velocity": 25,
            "instrument_str": "flute_synthetic_000",
            "instrument": 82,
            "sample_rate": 16000,
            "qualities_str": [
                "distortion"
            ],
            "instrument_source": 2,
            "note_str": "flute_synthetic_000-060-025",
            "instrument_family": 2,
            "instrument_family_str": "flute",
            "filepath": "./data/nsynth/nsynth-test/audio/flute_synthetic_000-060-025.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/flute_synthetic_000-060-025.wav"
    },
    {
        "x": 0.0,
        "y": 0.4704573154449463,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 102082,
            "instrument_source_str": "acoustic",
            "velocity": 50,
            "instrument_str": "guitar_acoustic_015",
            "instrument": 316,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "guitar_acoustic_015-060-050",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_acoustic_015-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_acoustic_015-060-050.wav"
    },
    {
        "x": 0.3800273835659027,
        "y": 0.9005779027938843,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 253526,
            "instrument_source_str": "electronic",
            "velocity": 25,
            "instrument_str": "organ_electronic_057",
            "instrument": 701,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_057-060-025",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_057-060-025.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_057-060-025.wav"
    },
    {
        "x": 0.9541237354278564,
        "y": 0.28157997131347656,
        "metadata": {
            "qualities": [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 68825,
            "instrument_source_str": "acoustic",
            "velocity": 100,
            "instrument_str": "string_acoustic_057",
            "instrument": 450,
            "sample_rate": 16000,
            "qualities_str": [
                "bright",
                "nonlinear_env",
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "string_acoustic_057-060-100",
            "instrument_family": 8,
            "instrument_family_str": "string",
            "filepath": "./data/nsynth/nsynth-test/audio/string_acoustic_057-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/string_acoustic_057-060-100.wav"
    },
    {
        "x": 0.21006160974502563,
        "y": 0.6285889148712158,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 150009,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "bass_electronic_018",
            "instrument": 759,
            "sample_rate": 16000,
            "qualities_str": [
                "fast_decay"
            ],
            "instrument_source": 1,
            "note_str": "bass_electronic_018-060-075",
            "instrument_family": 0,
            "instrument_family_str": "bass",
            "filepath": "./data/nsynth/nsynth-test/audio/bass_electronic_018-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/bass_electronic_018-060-075.wav"
    },
    {
        "x": 0.6151320338249207,
        "y": 0.347093790769577,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 24598,
            "instrument_source_str": "acoustic",
            "velocity": 75,
            "instrument_str": "reed_acoustic_011",
            "instrument": 104,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "reed_acoustic_011-060-075",
            "instrument_family": 7,
            "instrument_family_str": "reed",
            "filepath": "./data/nsynth/nsynth-test/audio/reed_acoustic_011-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/reed_acoustic_011-060-075.wav"
    },
    {
        "x": 0.8520981073379517,
        "y": 0.07091554999351501,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 242559,
            "instrument_source_str": "synthetic",
            "velocity": 50,
            "instrument_str": "bass_synthetic_134",
            "instrument": 914,
            "sample_rate": 16000,
            "qualities_str": [
                "dark",
                "reverb"
            ],
            "instrument_source": 2,
            "note_str": "bass_synthetic_134-060-050",
            "instrument_family": 0,
            "instrument_family_str": "bass",
            "filepath": "./data/nsynth/nsynth-test/audio/bass_synthetic_134-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/bass_synthetic_134-060-050.wav"
    },
    {
        "x": 0.3470146059989929,
        "y": 0.9625654220581055,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 154126,
            "instrument_source_str": "electronic",
            "velocity": 25,
            "instrument_str": "organ_electronic_113",
            "instrument": 958,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_113-060-025",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_113-060-025.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_113-060-025.wav"
    },
    {
        "x": 0.43992704153060913,
        "y": 0.9319270849227905,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 131318,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "organ_electronic_057",
            "instrument": 701,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_057-060-075",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_057-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_057-060-075.wav"
    },
    {
        "x": 0.5329658389091492,
        "y": 0.3361942172050476,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 99961,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "reed_acoustic_011",
            "instrument": 104,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "reed_acoustic_011-060-127",
            "instrument_family": 7,
            "instrument_family_str": "reed",
            "filepath": "./data/nsynth/nsynth-test/audio/reed_acoustic_011-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/reed_acoustic_011-060-127.wav"
    },
    {
        "x": 0.7601219415664673,
        "y": 0.6871610879898071,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 2490,
            "instrument_source_str": "acoustic",
            "velocity": 75,
            "instrument_str": "brass_acoustic_059",
            "instrument": 572,
            "sample_rate": 16000,
            "qualities_str": [
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "brass_acoustic_059-060-075",
            "instrument_family": 1,
            "instrument_family_str": "brass",
            "filepath": "./data/nsynth/nsynth-test/audio/brass_acoustic_059-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/brass_acoustic_059-060-075.wav"
    },
    {
        "x": 1.0,
        "y": 0.3065844476222992,
        "metadata": {
            "qualities": [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 39338,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "string_acoustic_057",
            "instrument": 450,
            "sample_rate": 16000,
            "qualities_str": [
                "bright",
                "nonlinear_env",
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "string_acoustic_057-060-127",
            "instrument_family": 8,
            "instrument_family_str": "string",
            "filepath": "./data/nsynth/nsynth-test/audio/string_acoustic_057-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/string_acoustic_057-060-127.wav"
    },
    {
        "x": 0.3591375946998596,
        "y": 0.4767409563064575,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 164977,
            "instrument_source_str": "acoustic",
            "velocity": 50,
            "instrument_str": "guitar_acoustic_014",
            "instrument": 263,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "guitar_acoustic_014-060-050",
            "instrument_family": 3,
            "instrument_family_str": "guitar",
            "filepath": "./data/nsynth/nsynth-test/audio/guitar_acoustic_014-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/guitar_acoustic_014-060-050.wav"
    },
    {
        "x": 0.5106973052024841,
        "y": 0.8637905120849609,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 289856,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "organ_electronic_001",
            "instrument": 8,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_001-060-075",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_001-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_001-060-075.wav"
    },
    {
        "x": 0.5669212341308594,
        "y": 0.29696470499038696,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 68462,
            "instrument_source_str": "acoustic",
            "velocity": 50,
            "instrument_str": "reed_acoustic_011",
            "instrument": 104,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "reed_acoustic_011-060-050",
            "instrument_family": 7,
            "instrument_family_str": "reed",
            "filepath": "./data/nsynth/nsynth-test/audio/reed_acoustic_011-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/reed_acoustic_011-060-050.wav"
    },
    {
        "x": 0.7289069890975952,
        "y": 0.3378051221370697,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 37025,
            "instrument_source_str": "acoustic",
            "velocity": 75,
            "instrument_str": "reed_acoustic_018",
            "instrument": 183,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "reed_acoustic_018-060-075",
            "instrument_family": 7,
            "instrument_family_str": "reed",
            "filepath": "./data/nsynth/nsynth-test/audio/reed_acoustic_018-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/reed_acoustic_018-060-075.wav"
    },
    {
        "x": 0.10564568638801575,
        "y": 0.5481789708137512,
        "metadata": {
            "qualities": [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 255000,
            "instrument_source_str": "electronic",
            "velocity": 75,
            "instrument_str": "keyboard_electronic_078",
            "instrument": 838,
            "sample_rate": 16000,
            "qualities_str": [
                "bright"
            ],
            "instrument_source": 1,
            "note_str": "keyboard_electronic_078-060-075",
            "instrument_family": 4,
            "instrument_family_str": "keyboard",
            "filepath": "./data/nsynth/nsynth-test/audio/keyboard_electronic_078-060-075.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/keyboard_electronic_078-060-075.wav"
    },
    {
        "x": 0.22280383110046387,
        "y": 0.6882469654083252,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 161661,
            "instrument_source_str": "synthetic",
            "velocity": 25,
            "instrument_str": "bass_synthetic_033",
            "instrument": 417,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 2,
            "note_str": "bass_synthetic_033-060-025",
            "instrument_family": 0,
            "instrument_family_str": "bass",
            "filepath": "./data/nsynth/nsynth-test/audio/bass_synthetic_033-060-025.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/bass_synthetic_033-060-025.wav"
    },
    {
        "x": 0.48307615518569946,
        "y": 0.9885464906692505,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 200277,
            "instrument_source_str": "electronic",
            "velocity": 100,
            "instrument_str": "organ_electronic_104",
            "instrument": 921,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 1,
            "note_str": "organ_electronic_104-060-100",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_104-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_104-060-100.wav"
    },
    {
        "x": 0.3115183711051941,
        "y": 0.5240960121154785,
        "metadata": {
            "qualities": [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ],
            "pitch": 60,
            "note": 5291,
            "instrument_source_str": "synthetic",
            "velocity": 50,
            "instrument_str": "bass_synthetic_034",
            "instrument": 420,
            "sample_rate": 16000,
            "qualities_str": [
                "distortion",
                "tempo-synced"
            ],
            "instrument_source": 2,
            "note_str": "bass_synthetic_034-060-050",
            "instrument_family": 0,
            "instrument_family_str": "bass",
            "filepath": "./data/nsynth/nsynth-test/audio/bass_synthetic_034-060-050.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/bass_synthetic_034-060-050.wav"
    },
    {
        "x": 0.2783556282520294,
        "y": 0.0826658308506012,
        "metadata": {
            "qualities": [
                0,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 211828,
            "instrument_source_str": "electronic",
            "velocity": 25,
            "instrument_str": "organ_electronic_007",
            "instrument": 123,
            "sample_rate": 16000,
            "qualities_str": [
                "distortion",
                "long_release",
                "nonlinear_env"
            ],
            "instrument_source": 1,
            "note_str": "organ_electronic_007-060-025",
            "instrument_family": 6,
            "instrument_family_str": "organ",
            "filepath": "./data/nsynth/nsynth-test/audio/organ_electronic_007-060-025.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/organ_electronic_007-060-025.wav"
    },
    {
        "x": 0.3531331717967987,
        "y": 0.6134077310562134,
        "metadata": {
            "qualities": [
                1,
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 19430,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "reed_acoustic_023",
            "instrument": 224,
            "sample_rate": 16000,
            "qualities_str": [
                "bright",
                "fast_decay",
                "multiphonic",
                "nonlinear_env"
            ],
            "instrument_source": 0,
            "note_str": "reed_acoustic_023-060-127",
            "instrument_family": 7,
            "instrument_family_str": "reed",
            "filepath": "./data/nsynth/nsynth-test/audio/reed_acoustic_023-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/reed_acoustic_023-060-127.wav"
    },
    {
        "x": 0.13762113451957703,
        "y": 0.4830280840396881,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0
            ],
            "pitch": 60,
            "note": 123938,
            "instrument_source_str": "acoustic",
            "velocity": 127,
            "instrument_str": "string_acoustic_056",
            "instrument": 436,
            "sample_rate": 16000,
            "qualities_str": [
                "fast_decay",
                "reverb"
            ],
            "instrument_source": 0,
            "note_str": "string_acoustic_056-060-127",
            "instrument_family": 8,
            "instrument_family_str": "string",
            "filepath": "./data/nsynth/nsynth-test/audio/string_acoustic_056-060-127.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/string_acoustic_056-060-127.wav"
    },
    {
        "x": 0.6263643503189087,
        "y": 0.05038842558860779,
        "metadata": {
            "qualities": [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 261631,
            "instrument_source_str": "electronic",
            "velocity": 100,
            "instrument_str": "keyboard_electronic_098",
            "instrument": 905,
            "sample_rate": 16000,
            "qualities_str": [
                "dark"
            ],
            "instrument_source": 1,
            "note_str": "keyboard_electronic_098-060-100",
            "instrument_family": 4,
            "instrument_family_str": "keyboard",
            "filepath": "./data/nsynth/nsynth-test/audio/keyboard_electronic_098-060-100.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/keyboard_electronic_098-060-100.wav"
    },
    {
        "x": 0.6830549240112305,
        "y": 0.3795912563800812,
        "metadata": {
            "qualities": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "pitch": 60,
            "note": 94894,
            "instrument_source_str": "acoustic",
            "velocity": 25,
            "instrument_str": "reed_acoustic_018",
            "instrument": 183,
            "sample_rate": 16000,
            "qualities_str": [],
            "instrument_source": 0,
            "note_str": "reed_acoustic_018-060-025",
            "instrument_family": 7,
            "instrument_family_str": "reed",
            "filepath": "./data/nsynth/nsynth-test/audio/reed_acoustic_018-060-025.wav"
        },
        "audio_path": "./data/nsynth/nsynth-test/audio/reed_acoustic_018-060-025.wav"
    }
]
export default pointData